import { BillingInterval } from '@graphql';
import { BillingMethod, BillingStatus, PlanType } from '../../pages/Organizations/_';

export const FILTERS_LABEL_MAP = {
  [PlanType.ALL]: 'All Types',
  [PlanType.ENTERPRISE]: 'Enterprise',
  [PlanType.PRO]: 'Pro',
  [PlanType.CORE]: 'Core',
  [BillingStatus.ALL]: 'All Statuses',
  [BillingStatus.ACTIVE]: 'Active',
  [BillingStatus.CANCELLED]: 'Cancelled',
  [BillingStatus.TRIALING]: 'Trialing',
  [BillingMethod.ALL]: 'All Methods',
  [BillingMethod.CREDIT_CARD]: 'Credit Card Method',
  [BillingMethod.INVOICE]: 'Invoice Method',
  [BillingInterval.monthly]: 'Monthly Interval',
  [BillingInterval.yearly]: 'Yearly Interval',
};
